import { Card, Col, Container, Row } from "react-bootstrap";
import AppLogo from "../assets/svgIcons/AppLogo";
import styled from "styled-components";
import { Outlet, useNavigate } from "react-router-dom";
import { media } from "../utils/helper";
import LogoutIcon from "../assets/svgIcons/LogoutIcon";
import StyledText from "./StyledComponents/StyledText";

const AppOutlet = ({ children, ...props }) => {
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  // const { user } = useUser();
  // const [linkSSO, { isLoading: getLinkSSOUrlLoading }] = useGetLinkSSOProviderUrlMutation();
  // const [getEmployeeListing] = useGetEmployeeListingMutation();
  // const [getUser] = useGetUserMutation();
  // const [showLinkProviders, setShowLinkProviders] = useState(false);

  // useEffect(() => {
  //   !user && setShowLinkProviders(true);
  // }, [user])

  // const callHandleSSO = (provider) => (handleSSO(provider, linkSSO, getUser, getEmployeeListing, dispatch, navigate), setShowLinkProviders(false))
  return (
    <OutletContainer>
      <Row>
        <Col>
          <div className="p-0 d-flex flex-column justify-content-center align-items-center ">
            <span className="mb-0 my-md-5 __app_logo d-flex align-items-center justify-content-between">
              <AppLogo size="230" className="logo" />
              <StyledText
                color="secondary"
                onClick={() => navigate("/logout")}
                className="d-block d-md-none"
              >
                <LogoutIcon size={20} />
              </StyledText>
            </span>

            <UserDetailsCard className="border-0 p-3 p-md-5 w-100">
              {children ? children : <Outlet {...props} />}
            </UserDetailsCard>
          </div>
        </Col>
      </Row>
      {/* <LinkProviderModal
        show={showLinkProviders}
        onSubmit={(provider) => callHandleSSO(provider)}
        loading={getLinkSSOUrlLoading}
        onHide={() => setShowLinkProviders(false)}
      /> */}
    </OutletContainer>
  );
};

const OutletContainer = styled(Container)`
  max-width: 880px;
  ${media.md`
      min-width:100% !important;
      max-width:100% !important;
      .col {
        padding: 0;
        .__app_logo {
           background-color: ${({ theme }) => theme.colors.white};
           width: 100%;
           display: flex;
           align-items: center;
           justify-content: center;
           padding: 25px;
           .logo {
              width: 138px;
           }
        }
      }`}
`;
const UserDetailsCard = styled(Card)`
  box-shadow: 1px 1px 40px 0 #00000005;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.white};

  .__card-header {
    background-color: ${({ theme }) => theme.colors.primaryLight};
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    min-height: 76px;
    position: relative;

    ${media.md`
         justify-content: center;
    `}
    .rounded-circle {
      background-color: ${({ theme }) => theme.colors.lightGray};

      ${media.md`
          width: 85px;
          height: 85px;
          background-color: ${({ theme }) => theme.colors.white};
          position: absolute;
          bottom: -40px;
          box-shadow: 0px 4px 99px 0px #00000026;
      `}
    }

    .initials {
      font-size: 2rem;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.midGray};
    }
  }

  .__card-body {
    border: 0.5px solid ${({ theme }) => theme.colors.borderColor};
    border-top: 0;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;

    .__edit-personal-info {
      color: ${({ theme }) => theme.colors.secondary};
      background-color: ${({ theme }) => theme.colors.body};
      border-radius: 4px;

      .user-name {
        line-height: normal;
      }

      padding: 5px 30px;
    }

    ${media.md`
      margin-top: 5px;
      background-color: transparent;
      border-radius: 4px;
      border:0;
      .__card-body-inner {
        background-color: ${({ theme }) => theme.colors.white};
        border-radius: 4px;
        margin-top: 15px!important;
      }
    `}
  }

  ${media.md`
      background-color: ${({ theme }) => theme.colors.mobileBody};
      border-radius: 0 0 53px 53px;
      min-height: calc(100vh - 76.17px);
  `}
`;

export default AppOutlet;
